import { useIntl } from 'react-intl';
import { BillingStatsPayload } from '@rossum/api-client/billing';
import { Button, CircularProgress } from '@rossum/ui/material';
import { BillingEntity } from '../hooks/useBillingEntity';
import { useBillingStatsExport } from '../hooks/useBillingStatsExport';

export const ExportBillingStatsButton = ({
  billingEntity,
  exportFilters,
}: {
  billingEntity: BillingEntity;
  exportFilters: BillingStatsPayload;
}) => {
  const intl = useIntl();
  const { mutate: exportStats, isLoading } = useBillingStatsExport();

  return (
    <Button
      color="secondary"
      variant="outlined"
      onClick={() => exportStats({ billingEntity, payload: exportFilters })}
      disabled={isLoading}
      startIcon={isLoading ? <CircularProgress size={16} /> : null}
    >
      {intl.formatMessage({
        id: 'containers.billing.export',
      })}
    </Button>
  );
};
